import { Box, Stack, TextField } from 'braid-design-system';
import React, {
  type ChangeEvent,
  type FocusEvent,
  type ReactText,
} from 'react';

import { CharacterCounter } from 'src/app/v1/views/shared/CharacterCounter';

interface Props {
  ariaLabel?: string;
  data: Record<string, ReactText>;
  id: string;
  isValid?: boolean;
  label?: string;
  maxCharacters: number;
  message?: string | null;
  onBlur?: (event: FocusEvent<HTMLInputElement>) => void;
  onChange?: (event: ChangeEvent<HTMLInputElement>) => void;
  secondaryLabel?: string;
  value: string;
}

export const TextFieldWithCounter = ({
  ariaLabel,
  data,
  id,
  isValid = true,
  label,
  maxCharacters,
  message,
  onBlur,
  onChange = () => {},
  secondaryLabel,
  value,
}: Props) => (
  <Box position="relative">
    <Stack space="xxsmall">
      <TextField
        id={id}
        label={label}
        aria-label={ariaLabel}
        secondaryLabel={secondaryLabel}
        message={message}
        onBlur={onBlur}
        onChange={onChange}
        value={value}
        tone={isValid ? 'neutral' : 'critical'}
        data={data}
        reserveMessageSpace
      />
      <CharacterCounter maxLength={maxCharacters} value={value} />
    </Stack>
  </Box>
);
